import { ICardsOfferProps } from '../components/partner-pages/page-sections/rewards-section/exciting_offers/cards-offers';

export enum collectionType {
  corporates = 'corporates',
  bfsi = 'bfsi',
  payroll = 'payroll',
  crypto = 'crypto',
  stocks = 'stocks',
}

export type sectionCardsWithBool = {
  plans: Array<string>;
  active: boolean;
};

type TPartnerFAQ = {
  question: string;
  answer: string;
};

export type TFAQSection = {
  customEnabled: boolean;
  faqs: TPartnerFAQ[];
};

export type TSectionDefault = {
  title: string;
  description: string;
};

export type TTradingFold = TSectionDefault & {
  active: boolean;
  cards: Array<{
    title: string;
    icon: string;
    href: string;
  }>;
};

export type TReportFold = TSectionDefault & {
  active: boolean;
  steps: Array<{
    title: string;
    icon: string;
    richText: string;
  }>;
};

export type TDirectorMessage = {
  active: boolean;
  name: string;
  designation: string;
  message: string;
  icon: string;
};

type TGotYouCoveredFold = {
  active: boolean;
};

export interface CorporatePage {
  blackBanner: boolean;
  collection: collectionType;
  createdOn?: string;
  headerTitle: string;
  heroTitle: string;
  heroDescription: string;
  id?: string;
  logo: string;
  logoRedirection: string;
  name: string;
  publishedOn?: string;
  seoDescription: string;
  seoTitle: string;
  seoKeywords: string;
  noindex: boolean;
  faqSection: TFAQSection;
  slug: string;
  updatedOn?: string;
  eas_business: sectionCardsWithBool;
  gotYouCoveredFold: TGotYouCoveredFold;
  tradingFold: TTradingFold;
  reportFold: TReportFold;
  directorMessage: TDirectorMessage;
  eas_itr: sectionCardsWithBool;
  self_itr: sectionCardsWithBool;
  generic_section: sectionCardsWithBool;
  pocEmail: string;
  pocName: string;
  pocPhone: string;
  webinarUrl: string;
  chatfiling: ChatFiling;
}

export type pagePropParams = {
  params: {
    static: string | null;
  };
};
type ChatFiling = {
  open_enable: boolean;
  slack: string;
  whatsapp: string;
  teams: string;
};
export type TCardDefaults = {
  [key: string]: {
    name: string;
    image: string;
  };
};

export type DefaultMeta = {
  id?: string;
  key: string;
  reward_data: {
    heading: string;
    description: string;
    data: ICardsOfferProps[];
  };
  card_defaults: TCardDefaults;
  seo_meta: {
    [key: string]: {
      title: string;
      description: string;
    };
  };
  section_defaults: {
    [key: string]: TSectionDefault;
  };
};

export interface IPARTNER_PAGE_PATH {
  paths: pagePropParams[];
  fallback: boolean;
}
